import { ManagementType } from  "@/interfaces/ExternalProvider";
import { GrantType, ResourcePermission, UserStatus } from  "@/interfaces/orgSettings";

export const isOrganisationAdmin = (permission: ResourcePermission, grantType: GrantType): boolean => {
    return (permission === ResourcePermission.MANAGE && grantType === GrantType.INFERRED);
};

export const isContentEditor = (permission: ResourcePermission, grantType: GrantType): boolean => {
    return (permission === ResourcePermission.MANAGE && grantType === GrantType.DIRECT);
};

export const hasEditorPermissions = (permission: ResourcePermission): boolean => {
    return (permission === ResourcePermission.MANAGE);
};

export const userProfileUrl = (userId: number) : string => {
    return `../admin/OrganizationUser/EditProfile/${userId}`
}

export function getStatus(status: UserStatus){
    if(!status) {
        return ''
    }
    return status === UserStatus.INACTIVE
        ? 'Archived'
        : status
}

export function getAddPasskeyLink() : string {
    return `/passkey/addpasskey?returnPath=${globalThis.location.pathname}`
}

export function getSignInWithDeviceLink() : string {
    return `/account/SignInWithDeviceCode?returnPath=${globalThis.location.pathname}`
}

export function isExternallyManaged(managementType?: ManagementType) : boolean {
    if (!managementType) {
        return false
    }
    return managementType === ManagementType.external
}